import * as types from 'store/mutation-types'
import store from '../index'
import { parseLocale } from 'i18n'
import { i18n } from 'app/config'
import { checkAvailableLocale } from 'app/i18n'
import ToastUtils from '@hotmart-org-ca/cosmos/dist/toast/utils'

const state = {
  notifications: []
}

const actions = {
  [types.SHOW_NOTIFICATION] (store, params) {
    const [message, type] = params ?? []
    const types = ['info', 'danger', 'success']
    const typeToUse = types.includes(type) ? type : 'info'
    if (message) {
      ToastUtils[typeToUse]({message: message, position: 'top right'})
    }
  },
  [types.AUTO_HIDE_NOTIFICATION] ({ state, dispatch }) {
    window.setTimeout(() => {
      dispatch(types.HIDE_NOTIFICATION)
    }, 4000)
  },
  [types.HIDE_NOTIFICATION] ({ commit }) {
    commit(types.HIDE_NOTIFICATION)
  },
  async [types.SHOW_TRANSLATED_NOTIFICATION] ({ dispatch }, [messageKey, type, position]) {
    let i18nActive = window.navigator.language

    if (store.state.auth.user && store.state.auth.user.locale) {
      i18nActive = parseLocale(store.state.auth.user.locale)
    }
    i18nActive = checkAvailableLocale(i18nActive)
    const i18nMessages = await import(/* webpackChunkName: "i18n/[request]" */ `i18n/${i18nActive}.json`)
    i18n.setLocaleMessage(i18nActive, i18nMessages)
    const translatedMessage = await i18n.t(messageKey, i18nActive)

    dispatch(types.SHOW_NOTIFICATION, [translatedMessage, type, position])
  }
}

const mutations = {
  [types.SHOW_NOTIFICATION] (state, notification) {
    state.notifications.push(notification)
  },
  [types.HIDE_NOTIFICATION] (state, index) {
    state.notifications.shift()
  }
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
